module.exports = __webpack_public_path__ + "static/media/essential-oils-made-easy.831cc2c3.png";